import history from '@src/history';
export const USER_LOGOUT = 'USER_LOGOUT';
export const USER_LOGOUT_SUCCESS = 'USER_LOGOUT_SUCCESS';
import { success } from 'react-notification-system-redux';
import { CustomResponse } from 'gc-backend';
import store from '@src/store';
const notificationLogoutSuccess = {
  title: 'Sign Out Successful',
  message: 'You have been signed out of your account.',
  position: 'bl',
  autoDismiss: 0,
 // dismissible: 'none',
};

export type Actions = {
  USER_LOGOUT: { type: typeof USER_LOGOUT; payload: CustomResponse | null };
  USER_LOGOUT_SUCCESS: { type: typeof USER_LOGOUT_SUCCESS; payload: null };
};

export const actionCreators = {
  userLogout: (): Actions[typeof USER_LOGOUT] => {
    return {
      type: USER_LOGOUT,
      payload: null,
    };
  },
  userLogoutSuccess: (): Actions[typeof USER_LOGOUT_SUCCESS] => {
    // history.push('/');
    return {
      type: USER_LOGOUT_SUCCESS,
      payload: null,
    };
  },
  userLogoutSuccessNotification: (): void => {
    store.dispatch(success(notificationLogoutSuccess));
  },
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/header/actions.ts